import React, {Component} from 'react';
import {copiaTestoNegliAppunti} from '../../Helpers';

class ComandiServerTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.item

        return (
            <tr>
                <td className="collapsing">{c.idComandoServer}</td>
                <td className="collapsing">{c.nome}
                </td>
                <td className="collapsing">{c.descrizione}
                </td>
                <td className="collapsing no-print">
                    <a className="ui blue icon button" onClick={(ev) => (this.props.onExecuteCommand(ev, c))}><i
                        className="play icon"

                    ></i></a>
                </td>
            </tr>)
    }
}

export default ComandiServerTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ComandiServerTableRow.js
 **/